(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bnon-portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnon-portfolio-gallery-entrance')) {
    customElements.define('bnon-portfolio-gallery-entrance', class extends HTMLElement {
      connectedCallback() {
        if (this.entranceObserver) return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.entranceObserver = new IntersectionObserver(entries => {
          if (this.entrancePlayed || !entries.some(entry => entry.isIntersecting)) return;
          this.entrancePlayed = true;
          this.entranceObserver.disconnect();
          if (this.reduced.matches) {
            this.querySelector('[data-bnon-aubre-brand-text]')?.style.removeProperty('opacity');
            return;
          }

          this.entranceAnimations = [];
          const animate = (element, frames, options) => {
            if (element?.animate) this.entranceAnimations.push(element.animate(frames, options));
          };
          animate(this.querySelector('.bnon-portfolio-gallery__heading'), [
            { opacity: 0, transform: 'translateY(25px)' }, { opacity: 1, transform: 'none' },
          ], { duration: 700, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' });
          animate(this.querySelector('.bnon-portfolio-gallery__description'), [
            { opacity: 0, transform: 'translateY(15px)' }, { opacity: 1, transform: 'none' },
          ], { duration: 600, delay: 100, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' });
          animate(this.querySelector('.bnon-portfolio-gallery__eyebrow'), [{ opacity: 0 }, { opacity: 1 }], {
            duration: 500, delay: 200, easing: 'ease-out', fill: 'backwards',
          });

          const mobile = window.matchMedia('(max-width: 1023px)').matches;
          const mobileSlider = window.matchMedia('(max-width: 1023px)').matches;
          const cardFrames = [
            { opacity: 0, transform: `translateY(${mobile ? 90 : 150}px) scale(${mobile ? .94 : .92})` },
            { opacity: 1, transform: 'none' },
          ];
          const wrappers = Array.from(this.querySelectorAll('.bnon-portfolio-gallery__card-entrance'));
          const center = Math.floor(wrappers.length / 2);
          const order = wrappers.map((wrapper, index) => ({ wrapper, distance: Math.abs(index - center), index }))
            .sort((a, b) => a.distance - b.distance || a.index - b.index);
          if (!mobileSlider) {
            order.forEach(({ wrapper }, index) => {
              const options = {
                duration: mobile ? 800 : 980,
                delay: 400 + index * (mobile ? 70 : 80),
                easing: 'cubic-bezier(.16, 1, .3, 1)',
                fill: 'backwards',
              };
              animate(wrapper, cardFrames, options);

              const aubreBrand = wrapper.parentElement.querySelector(':scope > [data-bnon-aubre-brand]');
              const aubreText = aubreBrand?.querySelector('[data-bnon-aubre-brand-text]');
              if (aubreText) animate(aubreText, [
                { opacity: 0, transform: 'translate(-.15vw, calc(-.35vw + 150px)) scale(.92) rotateY(-8deg)' },
                { opacity: 1, transform: 'translate(-.15vw, -.35vw) rotateY(-8deg)' },
              ], { ...options, fill: 'both' });
            });
          }
        }, { threshold: .15, rootMargin: '0px 0px -20% 0px' });
        this.entranceObserver.observe(this.querySelector('.bnon-portfolio-gallery__stage') || this);
      }

      disconnectedCallback() {
        this.entranceObserver?.disconnect();
        this.entranceAnimations?.forEach(animation => animation.cancel());
      }
    });
  }

  if (!customElements.get('bnon-portfolio-brand')) {
    customElements.define('bnon-portfolio-brand', class extends HTMLElement {
      connectedCallback() {
        this.scheduleFit = () => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => this.fit());
        };
        this.sizeObserver = new ResizeObserver(this.scheduleFit);
        this.sizeObserver.observe(this.parentElement);
        this.textObserver = new MutationObserver(this.scheduleFit);
        this.textObserver.observe(this, { childList: true, characterData: true, subtree: true });
        document.fonts.addEventListener('loadingdone', this.scheduleFit);
        document.fonts.ready.then(() => {
          if (this.isConnected) this.scheduleFit();
        });
        this.scheduleFit();
      }

      fit() {
        const text = this.querySelector('span');
        if (!text) return;

        // Restore the responsive default before every measurement, so shorter
        // names and wider cards regain their original size. Layout widths are
        // measured before perspective, never from transformed bounding boxes.
        this.style.removeProperty('font-size');
        const style = getComputedStyle(this);
        const width = parseFloat(style.width);
        const defaultSize = parseFloat(style.fontSize);
        const textWidth = () => parseFloat(getComputedStyle(text).width);
        if (!width || textWidth() <= width) return;

        let low = 0;
        let high = defaultSize;
        for (let step = 0; step < 12; step += 1) {
          const size = (low + high) / 2;
          this.style.fontSize = `${size}px`;
          if (textWidth() <= width) low = size;
          else high = size;
        }
        this.style.fontSize = `${low}px`;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.fitFrame);
        this.sizeObserver.disconnect();
        this.textObserver.disconnect();
        document.fonts.removeEventListener('loadingdone', this.scheduleFit);
      }
    });
  }

  if (!customElements.get('bnon-portfolio-mobile-slider')) {
    customElements.define('bnon-portfolio-mobile-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        this.stage = this.querySelector('.bnon-portfolio-gallery__stage');
        this.cards = Array.from(this.querySelectorAll('[data-bnon-portfolio-card]'));
        this.previousButton = this.querySelector('[data-bnon-portfolio-previous]');
        this.nextButton = this.querySelector('[data-bnon-portfolio-next]');
        if (!this.stage || this.cards.length < 2) return;

        this.slots = [
          { x: -103.8598, z: 114.7955, width: 51.3128, yaw: 83.078 },
          { x: -88.7574, z: 59.1250, width: 51.4668, yaw: 55.772 },
          { x: -51.6753, z: 14.8027, width: 52.1527, yaw: 29.556 },
          { x: -0.5968, z: 0, width: 51.3013, yaw: 0 },
          { x: 51.4118, z: 14.8027, width: 51.6945, yaw: -29.844 },
          { x: 88.1919, z: 58.6933, width: 50.6820, yaw: -55.341 },
          { x: 103.2851, z: 114.1223, width: 50.1221, yaw: -81.656 },
        ];
        this.mobile = window.matchMedia('(max-width: 1023px)');
        this.navigation = window.matchMedia('(max-width: 480px)');
        this.activeIndex = 0;
        this.pointerId = null;
        this.startX = 0;
        this.startY = 0;
        this.dragged = false;
        this.suppressClickUntil = 0;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.mobile.addEventListener('change', () => this.syncMode(), options);
        this.navigation.addEventListener('change', () => this.syncNavigation(), options);
        this.stage.addEventListener('pointerdown', (event) => this.onPointerDown(event), options);
        this.stage.addEventListener('pointermove', (event) => this.onPointerMove(event), options);
        this.stage.addEventListener('pointerup', (event) => this.onPointerUp(event), options);
        this.stage.addEventListener('pointercancel', () => this.cancelDrag(), options);
        this.stage.addEventListener('click', (event) => {
          const suppressClick = this.dragged && performance.now() < this.suppressClickUntil;
          this.dragged = false;
          if (!suppressClick) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, { capture: true, signal: this.controller.signal });
        this.stage.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.previousButton?.addEventListener('click', () => {
          if (!this.navigation.matches || this.activeIndex <= 0) return;
          this.move(-1);
        }, options);
        this.nextButton?.addEventListener('click', () => {
          if (!this.navigation.matches || this.activeIndex >= this.cards.length - 1) return;
          this.move(1);
        }, options);

        this.syncMode();
        // The deferred section script only runs after the compiled CSS is
        // ready, so releasing this inline guard shows one stable gallery.
        this.stage.style.removeProperty('visibility');
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }

      syncMode() {
        if (this.mobile.matches) {
          this.setActive(this.activeIndex, false);
          return;
        }

        this.stage.classList.remove('is-dragging');
        this.cards.forEach((card) => {
          card.style.removeProperty('--gallery-x');
          card.style.removeProperty('--gallery-z');
          card.style.removeProperty('--gallery-width');
          card.style.removeProperty('--gallery-yaw');
          card.classList.remove('is-wrapping');
          delete card.dataset.mobileSlot;
          card.removeAttribute('aria-current');
        });
        this.syncNavigation();
      }

      setActive(index, animate = true) {
        const count = this.cards.length;
        this.activeIndex = (index + count) % count;
        if (!animate) this.stage.classList.add('is-initializing');

        this.cards.forEach((card, cardIndex) => {
          let relative = cardIndex - this.activeIndex;
          if (relative > Math.floor(count / 2)) relative -= count;
          if (relative < -Math.floor(count / 2)) relative += count;
          const previousSlot = Number(card.dataset.mobileSlot);
          const wrapsAcrossGallery = animate
            && Number.isFinite(previousSlot)
            && Math.abs(relative - previousSlot) > 1;
          const slot = this.slots[Math.max(0, Math.min(6, relative + 3))];
          card.classList.toggle('is-wrapping', wrapsAcrossGallery);
          card.dataset.mobileSlot = String(relative);
          card.style.setProperty('--gallery-x', `${slot.x}vw`);
          card.style.setProperty('--gallery-z', `${slot.z}vw`);
          card.style.setProperty('--gallery-width', `${slot.width}vw`);
          card.style.setProperty('--gallery-yaw', `${slot.yaw}deg`);
          if (cardIndex === this.activeIndex) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');

          if (wrapsAcrossGallery) {
            requestAnimationFrame(() => requestAnimationFrame(() => card.classList.remove('is-wrapping')));
          }
        });

        if (!animate) requestAnimationFrame(() => this.stage.classList.remove('is-initializing'));
        this.syncNavigation();
      }

      syncNavigation() {
        if (!this.previousButton || !this.nextButton) return;
        const visible = this.navigation.matches;
        this.previousButton.disabled = !visible || this.activeIndex <= 0;
        this.nextButton.disabled = !visible || this.activeIndex >= this.cards.length - 1;
      }

      move(direction) {
        this.setActive(this.activeIndex + direction);
      }

      onPointerDown(event) {
        if (!this.mobile.matches || event.pointerType === 'mouse' && event.button !== 0) return;
        this.pointerId = event.pointerId;
        this.startX = event.clientX;
        this.startY = event.clientY;
        this.dragged = false;
        this.stage.setPointerCapture?.(event.pointerId);
      }

      onPointerMove(event) {
        if (event.pointerId !== this.pointerId) return;
        const deltaX = event.clientX - this.startX;
        const deltaY = event.clientY - this.startY;
        if (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY)) {
          this.dragged = true;
          this.stage.classList.add('is-dragging');
          event.preventDefault();
        }
      }

      onPointerUp(event) {
        if (event.pointerId !== this.pointerId) return;
        const deltaX = event.clientX - this.startX;
        const deltaY = event.clientY - this.startY;
        const wasSwipe = this.dragged || (Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY));
        this.stage.releasePointerCapture?.(event.pointerId);
        this.pointerId = null;
        this.stage.classList.remove('is-dragging');
        if (wasSwipe) {
          this.dragged = true;
          this.suppressClickUntil = performance.now() + 600;
        }
        if (wasSwipe && Math.abs(deltaX) >= 36) this.move(deltaX < 0 ? 1 : -1);
      }

      cancelDrag() {
        if (this.dragged) this.suppressClickUntil = performance.now() + 600;
        this.pointerId = null;
        this.stage.classList.remove('is-dragging');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnon-portfolio-projects"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bnon-portfolio-projects-entrance')) {
    customElements.define('bnon-portfolio-projects-entrance', class extends HTMLElement {
      connectedCallback() {
        if (this.introObserver) return;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const intro = this.querySelector('.bnon-portfolio-projects__intro');
        const cards = Array.from(this.querySelectorAll('.bnon-portfolio-projects__card'));
        this.entranceAnimations = [];
        const animate = (element, frames, options) => {
          if (element?.animate) this.entranceAnimations.push(element.animate(frames, options));
        };

        this.introObserver = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.introObserver.disconnect();
          if (this.reduced.matches) return;
          animate(intro, [
            { opacity: 0, transform: 'translateY(15px)' },
            { opacity: 1, transform: 'none' },
          ], { duration: 600, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' });
        }, { threshold: .15 });
        if (intro) this.introObserver.observe(intro);

        this.cardsObserver = new IntersectionObserver(entries => {
          const enteringCards = entries
            .filter(entry => entry.isIntersecting)
            .map(entry => entry.target)
            .sort((a, b) => cards.indexOf(a) - cards.indexOf(b));
          enteringCards.forEach((card, index) => {
            this.cardsObserver.unobserve(card);
            if (this.reduced.matches) return;
            animate(card, [
              { opacity: 0, transform: 'translateY(30px)' },
              { opacity: 1, transform: 'none' },
            ], {
              duration: 680,
              delay: enteringCards.length > 1 ? index * 60 : 0,
              easing: 'cubic-bezier(.22, 1, .36, 1)',
              fill: 'both',
            });
          });
        }, { threshold: .12 });
        cards.forEach(card => this.cardsObserver.observe(card));
      }

      disconnectedCallback() {
        this.introObserver?.disconnect();
        this.cardsObserver?.disconnect();
        this.entranceAnimations?.forEach(animation => animation.cancel());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bnon-service-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-bnon-service-stack]';
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    class BnonServiceStack {
      constructor(section) {
        this.section = section;
        this.cards = Array.from(section.querySelectorAll('.bnon-service-card'));
        this.list = section.querySelector('.bnon-service-page__list');
        this.heading = section.querySelector('.bnon-service-page__heading');
        this.desktop = window.matchMedia('(min-width: 1200px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = window.matchMedia('(max-width: 480px)');
        this.current = this.cards.map(() => 0);
        this.target = this.cards.map(() => 0);
        this.enteredCards = new Set();
        this.frame = null;
        this.destroyed = false;
        this.desktopTimeline = null;
        this.layoutDirty = true;
        this.requestUpdate = this.requestUpdate.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.animate = this.animate.bind(this);
        this.handleMotionChange = this.handleMotionChange.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);
        this.handleHashChange = this.handleHashChange.bind(this);
        window.addEventListener('scroll', this.requestUpdate, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        window.addEventListener('hashchange', this.handleHashChange);
        this.reducedMotion.addEventListener('change', this.handleMotionChange);
        this.mobile.addEventListener('change', this.handleModeChange);
        this.desktop.addEventListener('change', this.handleModeChange);
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.cards.forEach((card) => this.resizeObserver.observe(card));
        }
        this.handleModeChange();
        requestAnimationFrame(() => this.handleHashChange());
      }

      enableMobileReveal() {
        this.heading?.classList.remove('is-stack-pinned');
        if (this.frame !== null) window.cancelAnimationFrame(this.frame);
        this.frame = null;
        this.cards.forEach((card) => {
          card.style.removeProperty('--bnon-service-dim');
          card.style.removeProperty('--bnon-service-scale');
          card.style.removeProperty('--bnon-service-lift');
        });
        this.section.classList.add('is-mobile-reveal-ready');
        if (this.reducedMotion.matches) {
          this.cards.forEach((card) => card.classList.add('is-mobile-visible'));
          return;
        }
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-mobile-visible');
            this.playEntrance(this.cards.indexOf(entry.target));
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        this.cards.forEach((card) => this.revealObserver.observe(card));
      }

      disableMobileReveal() {
        this.revealObserver?.disconnect();
        this.revealObserver = null;
        this.section.classList.remove('is-mobile-reveal-ready');
        this.cards.forEach((card) => card.classList.remove('is-mobile-visible'));
      }

      handleModeChange() {
        this.disableMobileReveal();
        this.layoutDirty = true;
        if (!this.desktop.matches) this.clearDesktopTimeline();
        if (this.mobile.matches) this.enableMobileReveal();
        else this.requestUpdate();
      }

      handleResize() {
        this.layoutDirty = true;
        this.requestUpdate();
      }

      clearDesktopTimeline() {
        this.desktopTimeline = null;
        this.section.classList.remove('is-desktop-timeline-ready');
        this.list.style.removeProperty('--bnon-service-tail-extra');
        this.cards.forEach((card) => {
          card.style.removeProperty('--bnon-service-runway-extra');
          card.style.removeProperty('--bnon-service-enter-offset');
        });
      }

      measureDesktopTimeline() {
        if (!this.layoutDirty && this.desktopTimeline) return;
        const gap = parseFloat(window.getComputedStyle(this.list).rowGap) || 0;
        const heights = this.cards.map((card) => card.offsetHeight);
        const tops = this.cards.map((card) => parseFloat(window.getComputedStyle(card).top) || 0);
        let rowTop = 0;

        this.desktopTimeline = this.cards.map((card, index) => {
          const isLast = index === this.cards.length - 1;
          const stackStep = isLast ? 0 : tops[index + 1] - tops[index];
          // Browser measurements put the previous full-card hold at the grid
          // gap. Allocate 1.8x that distance to an explicit hold, followed by
          // a separate transition based on the card's actual height/stack step.
          const hold = gap * 1.8;
          const transition = isLast ? 0 : Math.max(heights[index] - stackStep, 1);
          const extra = Math.max(hold - gap, 0);
          const phase = { start: rowTop - tops[index], hold, transition };
          // The final hold belongs to a separate grid track: putting it in
          // the sticky card's own margin would consume its bottom constraint.
          card.style.setProperty('--bnon-service-runway-extra', `${(isLast ? 0 : extra).toFixed(3)}px`);
          if (isLast) this.list.style.setProperty('--bnon-service-tail-extra', `${extra.toFixed(3)}px`);
          rowTop += heights[index] + gap + extra;
          return phase;
        });

        this.layoutDirty = false;
        this.section.classList.add('is-desktop-timeline-ready');
      }

      calculateDesktopTargets() {
        this.measureDesktopTimeline();
        const position = -this.list.getBoundingClientRect().top;
        const ease = (progress) => progress * progress * (3 - 2 * progress);

        this.cards.forEach((card, index) => {
          const phase = this.desktopTimeline[index];
          const progress = phase.transition
            ? clamp((position - phase.start - phase.hold) / phase.transition, 0, 1)
            : 0;
          // No dimming/scaling during the hold, even when a large viewport
          // can already show the next card below it.
          this.target[index] = ease(progress);

          const previous = this.desktopTimeline[index - 1];
          let offset = 0;
          if (previous && !this.reducedMotion.matches) {
            const incoming = clamp((position - previous.start - previous.hold) / previous.transition, 0, 1);
            // Native sticky still provides the scroll/stack geometry. This
            // bounded correction maps its linear incoming travel to the same
            // transition progress used by the outgoing card. It returns to
            // zero at arrival, so the CTA stays stationary throughout its hold.
            offset = previous.transition * (incoming - ease(incoming));
          }
          card.style.setProperty('--bnon-service-enter-offset', `${offset.toFixed(3)}px`);
        });
      }

      calculateTargets() {
        if (this.desktop.matches) {
          this.calculateDesktopTargets();
          return;
        }
        this.cards.forEach((card, index) => {
          const nextCard = this.cards[index + 1];
          if (!nextCard) {
            this.target[index] = 0;
            return;
          }

          const nextTop = nextCard.getBoundingClientRect().top;
          const nextStickyTop = parseFloat(window.getComputedStyle(nextCard).top) || 0;
          // Start the hand-off earlier and give it a longer scroll range so
          // stacked cards do not feel like they switch all at once.
          const transitionStart = Math.min(window.innerHeight * 0.92, nextStickyTop + card.offsetHeight * 0.88);
          const transitionDistance = Math.max(transitionStart - nextStickyTop, 1);
          this.target[index] = clamp((transitionStart - nextTop) / transitionDistance, 0, 1);
        });
      }

      syncHeadingPin() {
        if (!this.heading || !this.cards.length) return;

        const sectionRect = this.section.getBoundingClientRect();
        const lastCard = this.cards[this.cards.length - 1];
        const lastStickyTop = parseFloat(window.getComputedStyle(lastCard).top) || 0;
        const isPinned = this.desktop.matches
          && sectionRect.top <= 80
          && lastCard.getBoundingClientRect().top >= lastStickyTop - 1;

        this.heading.classList.toggle('is-stack-pinned', isPinned);
      }

      activeCardIndex() {
        if (this.desktop.matches && this.desktopTimeline) {
          const position = -this.list.getBoundingClientRect().top;
          return this.desktopTimeline.reduce((active, phase, index) => position >= phase.start ? index : active, 0);
        }
        let active = 0;
        this.target.forEach((progress, index) => {
          if (progress > .12) active = Math.min(index + 1, this.cards.length - 1);
        });
        return active;
      }

      playEntrance(index) {
        // Desktop cards now move as a unit on the scroll timeline. Their text
        // and CTA are fully visible at arrival, with no separate timed reveal.
        if (this.desktop.matches) return;
        if (this.reducedMotion.matches || this.enteredCards.has(index)) return;
        this.enteredCards.add(index);
        const card = this.cards[index];
        if (!card?.animate) return;
        const enter = (selector, distance, delay, imageOnly = false) => {
          const element = card.querySelector(selector);
          if (!element) return;
          this.entranceAnimations.push(element.animate(
            imageOnly
              ? [{ opacity: 0 }, { opacity: 1 }]
              : [{ opacity: 0, transform: `translateY(${distance}px)` }, { opacity: 1, transform: 'none' }],
            { duration: 700, delay, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' }
          ));
        };
        this.entranceAnimations ||= [];
        enter('.bnon-service-card__title', 16, 60);
        enter('.bnon-service-card__category', 12, 160);
        enter('.bnon-service-card__description', 12, 260);
        enter('.bnon-service-card__link', 10, 360);
        enter('.bnon-service-card__media', 0, 260, true);
        enter('.bnon-service-card__count', 0, 440, true);
      }

      handleHashChange() {
        const match = window.location.hash.match(/^#service-(0[1-5])$/);
        if (!match) return;
        const index = Number(match[1]) - 1;
        const card = this.cards[index];
        if (!card) return;
        window.cancelAnimationFrame(this.hashFrame);
        this.hashFrame = window.requestAnimationFrame(() => {
          const stickyTop = parseFloat(window.getComputedStyle(card).top) || 0;
          const list = card.parentElement;
          const listDocumentTop = list.getBoundingClientRect().top + window.scrollY;
          if (this.desktop.matches) this.measureDesktopTimeline();
          const rowGap = parseFloat(window.getComputedStyle(list).rowGap) || 0;
          const cardsBefore = this.cards.slice(0, index);
          const targetTop = Math.max(
            0,
            this.desktop.matches
              ? listDocumentTop + this.desktopTimeline[index].start
              : listDocumentTop
              + cardsBefore.reduce((position, previousCard) => position + previousCard.offsetHeight + rowGap, 0)
              - stickyTop
          );

          // Sticky cards report their current visual offset, not their original
          // grid row. Build the target from the static list flow instead.
          if (window.bnonLenis) window.bnonLenis.scrollTo(targetTop, { immediate: true, force: true });
          else window.scrollTo({ top: targetTop, behavior: 'auto' });
          this.playEntrance(index);
          this.requestUpdate();
        });
      }

      renderCard(card, progress) {
        card.style.setProperty('--bnon-service-dim', (progress * 0.36).toFixed(4));
        card.style.setProperty('--bnon-service-scale', (1 - progress * 0.025).toFixed(4));
        card.style.setProperty('--bnon-service-lift', `${(progress * -6).toFixed(2)}px`);
      }

      animate() {
        this.frame = null;
        if (this.destroyed || this.mobile.matches) return;
        this.calculateTargets();
        this.syncHeadingPin();
        let needsAnotherFrame = false;

        this.cards.forEach((card, index) => {
          if (this.reducedMotion.matches) {
            this.current[index] = this.target[index];
          } else {
            this.current[index] += (this.target[index] - this.current[index]) * 0.12;
          }

          if (Math.abs(this.target[index] - this.current[index]) > 0.001) {
            needsAnotherFrame = true;
          } else {
            this.current[index] = this.target[index];
          }
          this.renderCard(card, this.current[index]);
        });

        this.playEntrance(this.activeCardIndex());

        if (needsAnotherFrame) this.frame = window.requestAnimationFrame(this.animate);
      }

      requestUpdate() {
        if (this.mobile.matches) return;
        if (this.frame === null) this.frame = window.requestAnimationFrame(this.animate);
      }

      handleMotionChange() {
        if (this.mobile.matches) this.handleModeChange();
        else this.requestUpdate();
      }

      destroy() {
        this.destroyed = true;
        window.removeEventListener('scroll', this.requestUpdate);
        window.removeEventListener('resize', this.handleResize);
        this.reducedMotion.removeEventListener('change', this.handleMotionChange);
        this.mobile.removeEventListener('change', this.handleModeChange);
        this.desktop.removeEventListener('change', this.handleModeChange);
        window.removeEventListener('hashchange', this.handleHashChange);
        this.disableMobileReveal();
        this.resizeObserver?.disconnect();
        this.clearDesktopTimeline();
        this.entranceAnimations?.forEach((animation) => animation.cancel());
        window.cancelAnimationFrame(this.hashFrame);
        if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      }
    }

    const instances = new WeakMap();
    const init = (scope = document) => {
      scope.querySelectorAll(selector).forEach((section) => {
        if (!instances.has(section)) instances.set(section, new BnonServiceStack(section));
      });
    };
    const unload = (event) => {
      const section = event.target.querySelector(selector);
      const instance = section && instances.get(section);
      if (!instance) return;
      instance.destroy();
      instances.delete(section);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', unload);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
